import { Link } from 'react-router'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { ListSkeleton } from '@/components/loading'
import { useRecentPatientsWidget } from './RecentPatientsWidget.logic'

export function RecentPatientsWidget() {
  const { t, patients, isLoading, isEmpty } = useRecentPatientsWidget()

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>{t('recentPatients')}</CardTitle>
        <Button variant="ghost" size="sm" asChild>
          <Link to="/patients">{t('viewAll')}</Link>
        </Button>
      </CardHeader>
      <CardContent>
        {isLoading && <ListSkeleton items={5} />}

        {isEmpty && <p className="text-sm text-muted-foreground">{t('noData')}</p>}

        {!isLoading && !isEmpty && (
          <div className="space-y-3">
            {patients.map((patient) => (
              <Link
                key={patient.id}
                to={`/patients/${patient.id}`}
                className="flex items-center gap-4 rounded-lg border p-3 transition-colors hover:bg-muted/50"
              >
                <div className="flex size-10 shrink-0 items-center justify-center rounded-full bg-primary/10 text-sm font-medium text-primary">
                  {patient.firstName[0]}
                  {patient.lastName[0]}
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium">
                    {patient.firstName} {patient.lastName}
                  </p>
                  {patient.admissionDate && (
                    <p className="text-xs text-muted-foreground">
                      {t('admittedOn')} {new Date(patient.admissionDate).toLocaleDateString()}
                    </p>
                  )}
                </div>
              </Link>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  )
}
